import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9359f98e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "me-3 fs_14 text-muted"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "formContainer"
}
const _hoisted_6 = { class: "d-flex align-items-center justify-content-between mb-4 p-3 bg-light rounded" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "me-2" }
const _hoisted_11 = { class: "badge bg-primary ms-2" }
const _hoisted_12 = { class: "badge bg-info ms-1" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "card-body"
}
const _hoisted_16 = { class: "field-grid section-grid" }
const _hoisted_17 = { class: "field-group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Section ID", -1))
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = { class: "field-group" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Title (EN)", -1))
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = { class: "field-group" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Title (IT)", -1))
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = { class: "field-group" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Weight", -1))
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = { class: "field-group" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Red Flags", -1))
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: true }, "Yes", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: false }, "No", -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_36 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "question-header" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "question-body" }
const _hoisted_41 = { class: "row mb-3" }
const _hoisted_42 = { class: "col-sm-4" }
const _hoisted_43 = { class: "field-group" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Question ID", -1))
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = { class: "col-sm-4" }
const _hoisted_47 = { class: "field-group" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Order", -1))
const _hoisted_49 = ["onUpdate:modelValue"]
const _hoisted_50 = { class: "col-sm-4" }
const _hoisted_51 = ["for"]
const _hoisted_52 = ["id", "checked", "onChange"]
const _hoisted_53 = { class: "row mb-3" }
const _hoisted_54 = { class: "col-sm-6" }
const _hoisted_55 = { class: "field-group field-grow" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Text (EN)", -1))
const _hoisted_57 = ["onUpdate:modelValue"]
const _hoisted_58 = { class: "col-sm-6" }
const _hoisted_59 = { class: "field-group field-grow" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Text (IT)", -1))
const _hoisted_61 = ["onUpdate:modelValue"]
const _hoisted_62 = { class: "row mb-3" }
const _hoisted_63 = { class: "col-sm-3" }
const _hoisted_64 = { class: "field-group" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Type", -1))
const _hoisted_66 = ["onUpdate:modelValue"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Yes/No/Partially", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 1 }, "Yes/No", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 2 }, "Informational", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 3 }, "Cert. Checklist", -1))
const _hoisted_71 = [
  _hoisted_67,
  _hoisted_68,
  _hoisted_69,
  _hoisted_70
]
const _hoisted_72 = { class: "col-sm-3" }
const _hoisted_73 = { class: "field-group" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Red Flag", -1))
const _hoisted_75 = ["onUpdate:modelValue"]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, "None", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 1 }, "Red Flag", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 2 }, "High Red Flag", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 3 }, "Reverse High RF", -1))
const _hoisted_80 = [
  _hoisted_76,
  _hoisted_77,
  _hoisted_78,
  _hoisted_79
]
const _hoisted_81 = { class: "col-sm-3" }
const _hoisted_82 = { class: "field-group" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Evidence", -1))
const _hoisted_84 = ["onUpdate:modelValue"]
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: true }, "Yes", -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: false }, "No", -1))
const _hoisted_87 = [
  _hoisted_85,
  _hoisted_86
]
const _hoisted_88 = { class: "col-sm-3" }
const _hoisted_89 = { class: "field-group" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Required", -1))
const _hoisted_91 = ["onUpdate:modelValue"]
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: true }, "Yes", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: false }, "No", -1))
const _hoisted_94 = [
  _hoisted_92,
  _hoisted_93
]
const _hoisted_95 = { class: "file-upload-setting" }
const _hoisted_96 = { class: "field-group" }
const _hoisted_97 = { class: "field-label" }
const _hoisted_98 = ["onUpdate:modelValue"]
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: true }, "Yes", -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: false }, "No", -1))
const _hoisted_101 = [
  _hoisted_99,
  _hoisted_100
]
const _hoisted_102 = { class: "field-group" }
const _hoisted_103 = { class: "field-label" }
const _hoisted_104 = ["onUpdate:modelValue"]
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: true }, "Yes", -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: false }, "No", -1))
const _hoisted_107 = [
  _hoisted_105,
  _hoisted_106
]
const _hoisted_108 = { class: "file-upload-hint" }
const _hoisted_109 = {
  key: 0,
  class: "sub-questions-area"
}
const _hoisted_110 = { class: "d-flex align-items-center justify-content-between mb-2" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sub-questions-title" }, "SUB-QUESTIONS", -1))
const _hoisted_112 = ["onClick"]
const _hoisted_113 = { class: "d-flex align-items-center justify-content-between mb-2" }
const _hoisted_114 = { class: "fw_700 fs_12" }
const _hoisted_115 = ["onClick"]
const _hoisted_116 = { class: "field-grid sub-text-grid mb-2" }
const _hoisted_117 = { class: "field-group" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Sub ID", -1))
const _hoisted_119 = ["onUpdate:modelValue"]
const _hoisted_120 = { class: "field-group" }
const _hoisted_121 = ["for"]
const _hoisted_122 = ["checked", "onChange"]
const _hoisted_123 = { class: "field-group field-grow" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Text (EN)", -1))
const _hoisted_125 = ["onUpdate:modelValue"]
const _hoisted_126 = { class: "field-group field-grow" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Text (IT)", -1))
const _hoisted_128 = ["onUpdate:modelValue"]
const _hoisted_129 = { class: "row" }
const _hoisted_130 = { class: "col-sm-4" }
const _hoisted_131 = { class: "field-group" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Type", -1))
const _hoisted_133 = ["onUpdate:modelValue"]
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Yes/No/P", -1))
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 1 }, "Yes/No", -1))
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 2 }, "Info", -1))
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 3 }, "Cert.", -1))
const _hoisted_138 = [
  _hoisted_134,
  _hoisted_135,
  _hoisted_136,
  _hoisted_137
]
const _hoisted_139 = { class: "col-sm-4" }
const _hoisted_140 = { class: "field-group" }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Red Flag", -1))
const _hoisted_142 = ["onUpdate:modelValue"]
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, "None", -1))
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 1 }, "Red Flag", -1))
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 2 }, "High RF", -1))
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 3 }, "Rev HRF", -1))
const _hoisted_147 = [
  _hoisted_143,
  _hoisted_144,
  _hoisted_145,
  _hoisted_146
]
const _hoisted_148 = { class: "col-sm-4" }
const _hoisted_149 = { class: "field-group" }
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Evidence", -1))
const _hoisted_151 = ["onUpdate:modelValue"]
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: true }, "Yes", -1))
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: false }, "No", -1))
const _hoisted_154 = [
  _hoisted_152,
  _hoisted_153
]
const _hoisted_155 = { class: "row" }
const _hoisted_156 = { class: "col-sm-4" }
const _hoisted_157 = { class: "field-group" }
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Score group", -1))
const _hoisted_159 = ["onUpdate:modelValue"]
const _hoisted_160 = { class: "col-sm-4" }
const _hoisted_161 = { class: "field-group" }
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Tier rank", -1))
const _hoisted_163 = ["onUpdate:modelValue"]
const _hoisted_164 = { class: "file-upload-setting sub" }
const _hoisted_165 = { class: "field-group" }
const _hoisted_166 = { class: "field-label" }
const _hoisted_167 = ["onUpdate:modelValue"]
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: true }, "Yes", -1))
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: false }, "No", -1))
const _hoisted_170 = [
  _hoisted_168,
  _hoisted_169
]
const _hoisted_171 = { class: "field-group" }
const _hoisted_172 = { class: "field-label" }
const _hoisted_173 = ["onUpdate:modelValue"]
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: true }, "Yes", -1))
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: false }, "No", -1))
const _hoisted_176 = [
  _hoisted_174,
  _hoisted_175
]
const _hoisted_177 = {
  key: 1,
  class: "sub-questions-area"
}
const _hoisted_178 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Survey Template Editor",
        text: "Survey Template Editor",
        class: "mb-0"
      }),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.template.version)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, " v" + _toDisplayString(_ctx.template.version), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "btn btn-tertiary",
          disabled: _ctx.saving,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.save()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Save Template",
            text: "Save Template"
          })
        ], 8, _hoisted_4)
      ])
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Total Section Weights",
                  text: "Total Section Weights"
                }),
                _createTextVNode(": ")
              ]),
              _createElementVNode("span", {
                class: _normalizeClass([_ctx.totalWeight == 100 ? 'text-success' : 'text-danger', "fw_700 ms-2"])
              }, _toDisplayString(_ctx.totalWeight) + " / 100 ", 3)
            ]),
            _createElementVNode("button", {
              class: "btn btn-sm btn-primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addSection()))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Add Section",
                text: "Add Section"
              })
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.template.sections, (section, sIdx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mb-4",
              key: section.sectionId
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "card-header d-flex align-items-center justify-content-between",
                  onClick: ($event: any) => (_ctx.toggleSection(sIdx))
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("strong", _hoisted_10, _toDisplayString(section.sectionId), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.getSectionTitle(section)), 1),
                    _createElementVNode("span", _hoisted_11, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Weight",
                        text: "Weight"
                      }),
                      _createTextVNode(": " + _toDisplayString(section.weight), 1)
                    ]),
                    _createElementVNode("span", _hoisted_12, [
                      _createTextVNode(_toDisplayString(section.questions.length) + " ", 1),
                      _createVNode(_component_localized_text, {
                        localizedKey: "questions",
                        text: "questions"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-outline-danger me-2",
                      onClick: _withModifiers(($event: any) => (_ctx.removeSection(sIdx)), ["stop"])
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Remove",
                        text: "Remove"
                      })
                    ], 8, _hoisted_14),
                    _createElementVNode("span", null, _toDisplayString(_ctx.expandedSections[sIdx] ? '▲' : '▼'), 1)
                  ])
                ], 8, _hoisted_8),
                (_ctx.expandedSections[sIdx])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": ($event: any) => ((section.sectionId) = $event)
                          }, null, 8, _hoisted_19), [
                            [_vModelText, section.sectionId]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": ($event: any) => ((section.title.values['en-US']) = $event)
                          }, null, 8, _hoisted_22), [
                            [_vModelText, section.title.values['en-US']]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": ($event: any) => ((section.title.values['it-IT']) = $event)
                          }, null, 8, _hoisted_25), [
                            [_vModelText, section.title.values['it-IT']]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": ($event: any) => ((section.weight) = $event),
                            min: "0",
                            max: "100"
                          }, null, 8, _hoisted_28), [
                            [
                              _vModelText,
                              section.weight,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select form-select-sm",
                            "onUpdate:modelValue": ($event: any) => ((section.hasRedFlags) = $event),
                            style: {"height":"31px"}
                          }, _hoisted_34, 8, _hoisted_31), [
                            [_vModelSelect, section.hasRedFlags]
                          ])
                        ])
                      ]),
                      _hoisted_35,
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("strong", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Questions",
                            text: "Questions"
                          })
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-primary",
                          onClick: ($event: any) => (_ctx.addQuestion(section))
                        }, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Add Question",
                            text: "Add Question"
                          })
                        ], 8, _hoisted_37)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.questions, (question, qIdx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "question-card",
                          key: question.questionId
                        }, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("strong", null, _toDisplayString(question.questionId), 1),
                            _createElementVNode("button", {
                              class: "btn btn-sm btn-outline-danger",
                              onClick: ($event: any) => (_ctx.removeQuestion(section, qIdx))
                            }, "×", 8, _hoisted_39)
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("div", _hoisted_43, [
                                  _hoisted_44,
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control form-control-sm",
                                    "onUpdate:modelValue": ($event: any) => ((question.questionId) = $event)
                                  }, null, 8, _hoisted_45), [
                                    [_vModelText, question.questionId]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("div", _hoisted_47, [
                                  _hoisted_48,
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    class: "form-control form-control-sm",
                                    "onUpdate:modelValue": ($event: any) => ((question.sortOrder) = $event),
                                    min: "0"
                                  }, null, 8, _hoisted_49), [
                                    [
                                      _vModelText,
                                      question.sortOrder,
                                      void 0,
                                      { number: true }
                                    ]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_50, [
                                _createElementVNode("label", {
                                  class: "field-label",
                                  for: 'scored_' + question.questionId,
                                  style: {"display":"block"}
                                }, "Scored", 8, _hoisted_51),
                                _createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  id: 'scored_' + question.questionId,
                                  checked: question.weight > 0,
                                  onChange: ($event: any) => (question.weight = ($event.target as HTMLInputElement).checked ? 1 : 0),
                                  style: {"display":"block","height":"31px","width":"31px"}
                                }, null, 40, _hoisted_52)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("div", _hoisted_55, [
                                  _hoisted_56,
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: "form-control form-control-sm",
                                    rows: "4",
                                    "onUpdate:modelValue": ($event: any) => ((question.text.values['en-US']) = $event)
                                  }, null, 8, _hoisted_57), [
                                    [_vModelText, question.text.values['en-US']]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_58, [
                                _createElementVNode("div", _hoisted_59, [
                                  _hoisted_60,
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: "form-control form-control-sm",
                                    rows: "4",
                                    "onUpdate:modelValue": ($event: any) => ((question.text.values['it-IT']) = $event)
                                  }, null, 8, _hoisted_61), [
                                    [_vModelText, question.text.values['it-IT']]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_62, [
                              _createElementVNode("div", _hoisted_63, [
                                _createElementVNode("div", _hoisted_64, [
                                  _hoisted_65,
                                  _withDirectives(_createElementVNode("select", {
                                    class: "form-select form-select-sm",
                                    "onUpdate:modelValue": ($event: any) => ((question.questionType) = $event)
                                  }, _hoisted_71, 8, _hoisted_66), [
                                    [
                                      _vModelSelect,
                                      question.questionType,
                                      void 0,
                                      { number: true }
                                    ]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_72, [
                                _createElementVNode("div", _hoisted_73, [
                                  _hoisted_74,
                                  _withDirectives(_createElementVNode("select", {
                                    class: "form-select form-select-sm",
                                    "onUpdate:modelValue": ($event: any) => ((question.redFlagType) = $event)
                                  }, _hoisted_80, 8, _hoisted_75), [
                                    [
                                      _vModelSelect,
                                      question.redFlagType,
                                      void 0,
                                      { number: true }
                                    ]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_81, [
                                _createElementVNode("div", _hoisted_82, [
                                  _hoisted_83,
                                  _withDirectives(_createElementVNode("select", {
                                    class: "form-select form-select-sm",
                                    "onUpdate:modelValue": ($event: any) => ((question.hasEvidenceField) = $event)
                                  }, _hoisted_87, 8, _hoisted_84), [
                                    [_vModelSelect, question.hasEvidenceField]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_88, [
                                _createElementVNode("div", _hoisted_89, [
                                  _hoisted_90,
                                  _withDirectives(_createElementVNode("select", {
                                    class: "form-select form-select-sm",
                                    "onUpdate:modelValue": ($event: any) => ((question.isRequired) = $event)
                                  }, _hoisted_94, 8, _hoisted_91), [
                                    [_vModelSelect, question.isRequired]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_95, [
                              _createElementVNode("div", _hoisted_96, [
                                _createElementVNode("label", _hoisted_97, [
                                  _createVNode(_component_localized_text, {
                                    localizedKey: "Allow File Upload",
                                    text: "Allow File Upload"
                                  })
                                ]),
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-select form-select-sm",
                                  "onUpdate:modelValue": ($event: any) => ((question.allowFileUpload) = $event),
                                  style: {"max-width":"160px"}
                                }, _hoisted_101, 8, _hoisted_98), [
                                  [_vModelSelect, question.allowFileUpload]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_102, [
                                _createElementVNode("label", _hoisted_103, [
                                  _createVNode(_component_localized_text, {
                                    localizedKey: "Certificate document",
                                    text: "Certificate document"
                                  })
                                ]),
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-select form-select-sm",
                                  "onUpdate:modelValue": ($event: any) => ((question.isCertificateDocument) = $event),
                                  style: {"max-width":"160px"}
                                }, _hoisted_107, 8, _hoisted_104), [
                                  [_vModelSelect, question.isCertificateDocument]
                                ])
                              ]),
                              _createElementVNode("span", _hoisted_108, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Let suppliers attach a document to this answer. Does not affect scoring.",
                                  text: "Let suppliers attach a document to this answer. Does not affect scoring."
                                })
                              ])
                            ]),
                            (question.subQuestions && question.subQuestions.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                  _createElementVNode("div", _hoisted_110, [
                                    _hoisted_111,
                                    _createElementVNode("button", {
                                      class: "btn btn-sm btn-outline-primary",
                                      onClick: ($event: any) => (_ctx.addSubQuestion(question))
                                    }, "+", 8, _hoisted_112)
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.subQuestions, (sub, subIdx) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "sub-question-item",
                                      key: sub.subQuestionId
                                    }, [
                                      _createElementVNode("div", _hoisted_113, [
                                        _createElementVNode("span", _hoisted_114, _toDisplayString(sub.subQuestionId), 1),
                                        _createElementVNode("button", {
                                          class: "btn btn-sm btn-outline-danger",
                                          onClick: ($event: any) => (_ctx.removeSubQuestion(question, subIdx))
                                        }, "×", 8, _hoisted_115)
                                      ]),
                                      _createElementVNode("div", _hoisted_116, [
                                        _createElementVNode("div", _hoisted_117, [
                                          _hoisted_118,
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control form-control-sm",
                                            "onUpdate:modelValue": ($event: any) => ((sub.subQuestionId) = $event)
                                          }, null, 8, _hoisted_119), [
                                            [_vModelText, sub.subQuestionId]
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_120, [
                                          _createElementVNode("label", {
                                            class: "field-label",
                                            for: 'scored_' + question.questionId,
                                            style: {"display":"block"}
                                          }, "Scored", 8, _hoisted_121),
                                          _createElementVNode("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            checked: sub.weight > 0,
                                            onChange: ($event: any) => (sub.weight = ($event.target as HTMLInputElement).checked ? 1 : 0),
                                            style: {"display":"block","height":"31px","width":"31px"}
                                          }, null, 40, _hoisted_122)
                                        ]),
                                        _createElementVNode("div", _hoisted_123, [
                                          _hoisted_124,
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control form-control-sm",
                                            "onUpdate:modelValue": ($event: any) => ((sub.text.values['en-US']) = $event)
                                          }, null, 8, _hoisted_125), [
                                            [_vModelText, sub.text.values['en-US']]
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_126, [
                                          _hoisted_127,
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control form-control-sm",
                                            "onUpdate:modelValue": ($event: any) => ((sub.text.values['it-IT']) = $event)
                                          }, null, 8, _hoisted_128), [
                                            [_vModelText, sub.text.values['it-IT']]
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_129, [
                                        _createElementVNode("div", _hoisted_130, [
                                          _createElementVNode("div", _hoisted_131, [
                                            _hoisted_132,
                                            _withDirectives(_createElementVNode("select", {
                                              class: "form-select form-select-sm",
                                              "onUpdate:modelValue": ($event: any) => ((sub.questionType) = $event)
                                            }, _hoisted_138, 8, _hoisted_133), [
                                              [
                                                _vModelSelect,
                                                sub.questionType,
                                                void 0,
                                                { number: true }
                                              ]
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_139, [
                                          _createElementVNode("div", _hoisted_140, [
                                            _hoisted_141,
                                            _withDirectives(_createElementVNode("select", {
                                              class: "form-select form-select-sm",
                                              "onUpdate:modelValue": ($event: any) => ((sub.redFlagType) = $event)
                                            }, _hoisted_147, 8, _hoisted_142), [
                                              [
                                                _vModelSelect,
                                                sub.redFlagType,
                                                void 0,
                                                { number: true }
                                              ]
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_148, [
                                          _createElementVNode("div", _hoisted_149, [
                                            _hoisted_150,
                                            _withDirectives(_createElementVNode("select", {
                                              class: "form-select form-select-sm",
                                              "onUpdate:modelValue": ($event: any) => ((sub.hasEvidenceField) = $event)
                                            }, _hoisted_154, 8, _hoisted_151), [
                                              [_vModelSelect, sub.hasEvidenceField]
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_155, [
                                        _createElementVNode("div", _hoisted_156, [
                                          _createElementVNode("div", _hoisted_157, [
                                            _hoisted_158,
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              class: "form-control form-control-sm",
                                              "onUpdate:modelValue": ($event: any) => ((sub.scoreGroup) = $event),
                                              placeholder: "(none)"
                                            }, null, 8, _hoisted_159), [
                                              [_vModelText, sub.scoreGroup]
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_160, [
                                          _createElementVNode("div", _hoisted_161, [
                                            _hoisted_162,
                                            _withDirectives(_createElementVNode("input", {
                                              type: "number",
                                              min: "0",
                                              class: "form-control form-control-sm",
                                              "onUpdate:modelValue": ($event: any) => ((sub.scoreGroupRank) = $event)
                                            }, null, 8, _hoisted_163), [
                                              [
                                                _vModelText,
                                                sub.scoreGroupRank,
                                                void 0,
                                                { number: true }
                                              ]
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_164, [
                                        _createElementVNode("div", _hoisted_165, [
                                          _createElementVNode("label", _hoisted_166, [
                                            _createVNode(_component_localized_text, {
                                              localizedKey: "Allow File Upload",
                                              text: "Allow File Upload"
                                            })
                                          ]),
                                          _withDirectives(_createElementVNode("select", {
                                            class: "form-select form-select-sm",
                                            "onUpdate:modelValue": ($event: any) => ((sub.allowFileUpload) = $event),
                                            style: {"max-width":"140px"}
                                          }, _hoisted_170, 8, _hoisted_167), [
                                            [_vModelSelect, sub.allowFileUpload]
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_171, [
                                          _createElementVNode("label", _hoisted_172, [
                                            _createVNode(_component_localized_text, {
                                              localizedKey: "Certificate document",
                                              text: "Certificate document"
                                            })
                                          ]),
                                          _withDirectives(_createElementVNode("select", {
                                            class: "form-select form-select-sm",
                                            "onUpdate:modelValue": ($event: any) => ((sub.isCertificateDocument) = $event),
                                            style: {"max-width":"140px"}
                                          }, _hoisted_176, 8, _hoisted_173), [
                                            [_vModelSelect, sub.isCertificateDocument]
                                          ])
                                        ])
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_177, [
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-secondary",
                                    onClick: ($event: any) => (_ctx.addSubQuestion(question))
                                  }, [
                                    _createVNode(_component_localized_text, {
                                      localizedKey: "Add Sub-Question",
                                      text: "Add Sub-Question"
                                    })
                                  ], 8, _hoisted_178)
                                ]))
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}